
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gray-900 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/c209f1799ad125177e0fe6e14cfcc3f4/bdf32db5330139c638bdae03c6e017df.jpeg')`
        }}
      >
        <div className="absolute inset-0 bg-gray-900/80"></div>
      </div>

      <div className="relative z-10 container mx-auto px-6 text-left w-full">
        <div className="max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Premium Vehicle Wraps, Window Tinting &<span className="text-blue-400"> Professional Signs</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed max-w-3xl">
            Transform your vehicle, business, or home with our expert window tinting, custom wraps, and comprehensive signage solutions. Quality craftsmanship backed by years of experience.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <button className="bg-blue-600 text-white px-8 py-4 text-lg font-semibold rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap shadow-lg">
              Get Your Free Quote Today
            </button>
            <button className="border-2 border-blue-400 text-blue-400 px-8 py-4 text-lg font-semibold rounded-lg hover:bg-blue-400 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">
              View Our Work
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-gray-800/60 backdrop-blur-sm p-6 rounded-lg border border-gray-700">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 text-blue-400">
                <i className="ri-car-line text-3xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Vehicle Services</h3>
              <p className="text-gray-300 text-sm">Window tinting, custom wraps, and graphics</p>
            </div>

            <div className="bg-gray-800/60 backdrop-blur-sm p-6 rounded-lg border border-gray-700">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 text-blue-400">
                <i className="ri-building-line text-3xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Commercial Solutions</h3>
              <p className="text-gray-300 text-sm">Fleet branding, storefront graphics, signage</p>
            </div>

            <div className="bg-gray-800/60 backdrop-blur-sm p-6 rounded-lg border border-gray-700">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 text-blue-400">
                <i className="ri-home-line text-3xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Residential</h3>
              <p className="text-gray-300 text-sm">Home window tinting and privacy solutions</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
